import React from 'react';
import IntegratedHeader from './Headercomponent'; 
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

const ContactUs = () => {
  return (
    <div style={styles.container}>
      <IntegratedHeader />
      <div style={styles.content}>
        <section style={styles.contactSection}>
          <h2 style={styles.sectionTitle}>Contact Us</h2>
          <p style={styles.sectionSubtitle}>We're here to help! You can reach us through the following methods:</p>

          <div style={styles.contactDetails}>
            <div style={styles.contactBox}>
              <FaPhoneAlt style={styles.icon} />
              <h4 style={styles.contactTitle}>Phone</h4>
              <p style={styles.contactInfo}>+234 913 928 1851</p>
            </div>

            <div style={styles.contactBox}>
              <FaEnvelope style={styles.icon} />
              <h4 style={styles.contactTitle}>Email</h4>
              <p style={styles.contactInfo}>lihenpharmacy@gmail.com</p>
            </div>

            <div style={styles.contactBox}>
              <FaMapMarkerAlt style={styles.icon} />
              <h4 style={styles.contactTitle}>Address</h4>
              <p style={styles.contactInfo}>Vessel of Honor Complex, Ekhei Girls Road, Auchi, Edo State</p>
            </div>
          </div>

          <div style={styles.socialMedia}>
            <h4 style={styles.socialTitle}>Connect with us</h4>
            <div style={styles.socialIcons}>
              <FaFacebook style={styles.socialIcon} />
              <FaTwitter style={styles.socialIcon} />
              <FaInstagram style={styles.socialIcon} />
              <FaLinkedin style={styles.socialIcon} />
            </div>
          </div>
        </section>

        <section style={styles.mapSection}>
          <h2 style={styles.sectionTitle}>Find Us Here</h2>
          <div style={styles.mapContainer}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d770!2d6.2625727!3d7.0593874!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sng!4v1738259281654"
              style={styles.map}
              title="Location Map"
              allowFullScreen="true"
              loading="lazy"
            ></iframe>
          </div>
        </section>
      </div>
    </div>
  );
};

const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      margin: '0',
      padding: '0',
      boxSizing: 'border-box',
    },
    content: {
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto',
      boxSizing: 'border-box',
    },
    contactSection: {
      backgroundColor: '#fff',
      padding: '40px',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      marginBottom: '50px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    sectionTitle: {
      fontSize: '32px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '10px',
      textAlign: 'center',
    },
    sectionSubtitle: {
      fontSize: '18px',
      color: '#666',
      marginBottom: '30px',
      textAlign: 'center',
    },
    contactDetails: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      maxWidth: '1000px',
      margin: '0 auto',
      flexWrap: 'wrap', // Allow wrapping on smaller screens
    },
    contactBox: {
      backgroundColor: '#f9f9f9',
      padding: '30px',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      width: '48%', // Adjust the width for each box to 48% to make space for both phone and email boxes side by side
      margin: '10px',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      transition: 'transform 0.3s ease',
      minHeight: '200px', // Fixed height for rectangular shape
      flexGrow: 1, // Allow boxes to grow in width if necessary
      whiteSpace: 'nowrap', // Prevent text from breaking into new lines
      overflow: 'hidden', // Ensure the content doesn't overflow
    },
    icon: {
      fontSize: '40px',
      color: '#28a745',
      marginBottom: '10px',
    },
    contactTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '5px',
    },
    contactInfo: {
      fontSize: '16px',
      color: '#666',
      wordWrap: 'break-word', // Ensure text wraps if absolutely needed
      textAlign: 'center',
      whiteSpace: 'normal', // Allow text to break if really needed
    },
    socialMedia: {
      marginTop: '30px',
      textAlign: 'center',
    },
    socialTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '10px',
    },
    socialIcons: {
      display: 'flex',
      justifyContent: 'center',
      gap: '15px',
    },
    socialIcon: {
      fontSize: '30px',
      color: '#28a745',
      cursor: 'pointer',
      transition: 'color 0.3s',
    },
    mapSection: {
      marginTop: '60px',
      backgroundColor: '#fff',
      padding: '40px',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    mapContainer: {
      height: '400px',
      width: '100%',
      maxWidth: '800px',
      borderRadius: '10px',
      overflow: 'hidden',
    },
    map: {
      width: '100%',
      height: '100%',
      border: 'none',
    },
  
    // Media Queries for Responsiveness
    '@media (max-width: 768px)': {
      content: {
        padding: '10px',
      },
      contactDetails: {
        flexDirection: 'column', // Stack contact boxes vertically on smaller screens
        alignItems: 'center', // Center-align the boxes
      },
      contactBox: {
        width: '80%', // Make boxes take up more width on smaller screens
        marginBottom: '15px', // Add space between stacked boxes
        minHeight: 'auto', // Allow height to adjust based on content
        whiteSpace: 'normal', // Allow text to break if necessary
      },
      sectionTitle: {
        fontSize: '28px',
      },
      sectionSubtitle: {
        fontSize: '16px',
      },
      socialIcons: {
        gap: '10px',
      },
      socialIcon: {
        fontSize: '24px',
      },
      mapContainer: {
        height: '300px',
      },
    },
  
    '@media (max-width: 480px)': {
      contactBox: {
        width: '100%', // Make boxes take full width on very small screens
        padding: '20px', // Reduce padding for smaller screens
      },
      socialIcons: {
        gap: '5px',
      },
      socialIcon: {
        fontSize: '20px',
      },
      mapContainer: {
        height: '250px',
      },
    },
  };
  
  

export default ContactUs;
